import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=4c35a58f&"
import script from "./divider.vue?vue&type=script&lang=ts&"
export * from "./divider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports